export const getSecondsSinceEpoch = () => Math.round(new Date().getTime() / 1000)
